import Page from 'src/apipages/oembed/videos/index';

export default Page;
